export const EntityStatus = {
  JUMP: 1,
  HURT: 2, // legacy
  DEATH: 3,
  START_ATTACKING: 4,
  STOP_ATTACKING: 5,
  TAMING_FAILED: 6,
  TAMING_SUCCEEDED: 7,
  SHAKE_WETNESS: 8,
  USE_ITEM_COMPLETE: 9,
  EAT_GRASS: 10,
  OFFER_FLOWER: 11,
  LOVE_HEARTS: 12,
  VILLAGER_ANGRY: 13,
  VILLAGER_HAPPY: 14,
  WITCH_HAT_MAGIC: 15,
  ZOMBIE_CONVERTING: 16,
  FIREWORKS_EXPLODE: 17,
  IN_LOVE_HEARTS: 18,
  SQUID_ANIM_SYNCH: 19,
  SILVERFISH_MERGE_ANIM: 20,
  GUARDIAN_ATTACK_SOUND: 21,
  REDUCED_DEBUG_INFO: 22,
  FULL_DEBUG_INFO: 23,
  PERMISSION_LEVEL_ALL: 24,
  PERMISSION_LEVEL_MODERATORS: 25,
  PERMISSION_LEVEL_GAMEMASTERS: 26,
  PERMISSION_LEVEL_ADMINS: 27,
  PERMISSION_LEVEL_OWNERS: 28,
  ATTACK_BLOCKED: 29,
  SHIELD_DISABLED: 30,
  FISHING_ROD_REEL_IN: 31,
  ARMORSTAND_WOBBLE: 32,
  THORNED: 33, // legacy
  STOP_OFFER_FLOWER: 34,
  TALISMAN_ACTIVATE: 35, // legacy
  DROWNED: 36, // legacy
  BURNED: 37, // legacy
  DOLPHIN_LOOKING_FOR_TREASURE: 38,
  RAVAGER_STUNNED: 39,
  TRUSTING_FAILED: 40,
  TRUSTING_SUCCEEDED: 41,
  VILLAGER_SWEAT: 42,
  BAD_OMEN_TRIGGERED: 43, // legacy
  POKED: 44, // legacy
  FOX_EAT: 45,
  TELEPORT: 46,
  MAINHAND_BREAK: 47,
  OFFHAND_BREAK: 48,
  HEAD_BREAK: 49,
  CHEST_BREAK: 50,
  LEGS_BREAK: 51,
  FEET_BREAK: 52,
  HONEY_SLIDE: 53,
  HONEY_JUMP: 54,
  SWAP_HANDS: 55,
  CANCEL_SHAKE_WETNESS: 56,
  FROZEN: 57, // legacy
  START_RAM: 58,
  END_RAM: 59,
  POOF: 60,
  TENDRILS_SHIVER: 61,
  SONIC_CHARGE: 62,
  SNIFFER_DIGGING_SOUND: 63,
  ARMADILLO_PEEK: 64,
  BODY_BREAK: 65,
  SHAKE: 66
} as const

export type EntityStatusName = keyof typeof EntityStatus
